import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PedidoModel } from '../../models/pedido.model';
import { MetodosModal } from '../../interfaces/metodos-modal.interface';
import { ModalRoleEnum } from '../../enums/modal-role.enum';

@Component({
  selector: 'app-info-pedido',
  templateUrl: './info-pedido.component.html',
  styleUrls: ['./info-pedido.component.scss'],
})
export class InfoPedidoComponent implements OnInit, MetodosModal {
  pedido: PedidoModel;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() { }

  cancel() {
    this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
  }

  confirm() {

  }
}
